import React, { useEffect, useState } from "react";
import "../styles/Holiday.css";
import AddHolidayPopUp from "./add_holiday_popup.js";
import HolidayPopUp from "./holiday_popup.js";
import { secretKey, monthData } from "../.././data";
import Loading from "../helpers/loading_component.js";

const HolidayUserDetails = (props) => {
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState("");
  const [year, setYear] = useState(new Date().getFullYear());
  const [years, setYears] = useState([]);
  const [yearsData, setYearsData] = useState([]);
  const [display, setDisplay] = useState("");
  const [expandRemote, setExpandRemote] = useState(false);
  const [expandSick, setExpandSick] = useState(false);
  const [expandUsed, setExpandUsed] = useState(false);
  const [expandAccepted, setExpandAccepted] = useState(false);
  const [expandEkwiwalent, setExpandEkwiwalent] = useState(false);
  const [expandReported, setExpandReported] = useState(false);
  const [holidaysData, setHolidaysData] = useState([]);
  const [yearHolidaysData, setYearHolidaysData] = useState([]);
  const [freeDaysData, setFreeDaysData] = useState([]);
  const [holidaysBlockData, setHolidaysBlockData] = useState([]);

  const fetchHolidays = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getHolidays", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setHolidaysData(data);
        fetchFreeDays();
      })
      .catch((error) => {});
  };

  const fetchFreeDays = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getFreeDays", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setFreeDaysData(data);
        fetchHolidaysBlocks();
      })
      .catch((error) => {});
  };

  const fetchHolidaysBlocks = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getHolidaysBlocks", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setHolidaysBlockData(data);
        fetchYearHolidays();
      })
      .catch((error) => {});
  };

  const fetchYearHolidays = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getYearsHolidays", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setYearHolidaysData(data);

        var arr = props.users.filter((el) => el.name === props.name)[0];
        setUser(arr);
        var yearsU = data.filter((el) => el.name === arr.name);
        var arrY = [];
        yearsU.map((el) => {
          arrY.push(el.year);
        });

        setYears(arrY);
        setYearsData(yearsU);

        setLoading(false);
      })
      .catch((error) => {});
  };

  const getData = () => {
    setLoading(true);
    fetchHolidays();
  };

  useEffect(() => {
    getData();
  }, []);

  const checkFreeDay = (date) => {
    var bool = false;
    props.freeDaysData.map((el) => {
      if (
        date.getFullYear() +
          "-" +
          (date.getMonth() + 1 > 9
            ? date.getMonth() + 1
            : "0" + (date.getMonth() + 1)) +
          "-" +
          (date.getDate() > 9 ? date.getDate() : "0" + date.getDate()) ===
        el.date
      ) {
        bool = true;
      }
    });
    return bool;
  };

  const countDays = (holiday) => {
    var count = 0;
    for (
      var i = new Date(holiday.date_from);
      i <= new Date(holiday.date_to);
      i.setDate(i.getDate() + 1)
    ) {
      if (
        !(i.getDay() === 6) &&
        !(i.getDay() === 0) &&
        !checkFreeDay(i) &&
        +i.getFullYear() === +year
      ) {
        count++;
      }
    }
    return count;
  };

  const countDaysUsed = (holiday) => {
    var count = 0;
    for (
      var i = new Date(holiday.date_from);
      i <= new Date(holiday.date_to);
      i.setDate(i.getDate() + 1)
    ) {
      if (
        !(i.getDay() === 6 || i.getDay() === 0 || checkFreeDay(i)) &&
        +i.getFullYear() === +year
      ) {
        if (i < new Date()) {
          count++;
        }
      }
    }
    return count;
  };

  const getReportedDays = (name) => {
    var holidays = props.holidaysData.filter(
      (el) =>
        el.user === name && el.status === "REPORTED" && el.type === "holiday"
    );
    var days = 0;
    holidays.map((el) => {
      days = days + countDays(el);
    });
    return days;
  };

  const getReportedDaysMonth = (name, month) => {
    var holidays = props.holidaysData.filter(
      (el) =>
        el.user === name &&
        el.status === "REPORTED" &&
        el.type === "holiday" &&
        new Date(el.date_from).getMonth() + 1 === month
    );
    var days = 0;
    holidays.map((el) => {
      days = days + countDays(el);
    });
    return days;
  };

  const getAcceptedDays = (name) => {
    var holidays = props.holidaysData.filter(
      (el) =>
        el.user === name && el.status === "ACCEPTED" && el.type === "holiday"
    );
    var days = 0;
    holidays.map((el) => {
      days = days + countDays(el);
    });
    return days;
  };

  const getAcceptedDaysMonth = (name, month) => {
    var holidays = props.holidaysData.filter(
      (el) =>
        el.user === name &&
        el.status === "ACCEPTED" &&
        el.type === "holiday" &&
        new Date(el.date_from).getMonth() + 1 === month
    );
    var days = 0;
    holidays.map((el) => {
      days = days + countDays(el) - countDaysUsed(el);
    });
    return days;
  };

  const getEkwiwalentDaysMonth = (name, month) => {
    var holidays = holidaysData.filter(
      (el) =>
        el.user === name &&
        el.type === "ekwiwalent" &&
        new Date(el.date_from).getMonth() + 1 === month
    );
    var days = 0;
    holidays.map((el) => {
      days = days + countDays(el);
    });
    return days;
  };

  const getUsedDays = (name) => {
    var holidays = props.holidaysData.filter(
      (el) =>
        el.user === name && el.status === "ACCEPTED" && el.type === "holiday"
    );
    var days = 0;
    holidays.map((el) => {
      days = days + countDaysUsed(el);
    });
    return days;
  };

  const getUsedDaysMonth = (name, month) => {
    var holidays = props.holidaysData.filter(
      (el) =>
        el.user === name &&
        el.status === "ACCEPTED" &&
        el.type === "holiday" &&
        new Date(el.date_from).getMonth() + 1 === month
    );
    var days = 0;
    holidays.map((el) => {
      days = days + countDaysUsed(el);
    });
    return days;
  };

  const getSickDays = (name) => {
    var holidays = props.holidaysData.filter(
      (el) => el.user === name && el.status === "ACCEPTED" && el.type === "sick"
    );
    var days = 0;
    holidays.map((el) => {
      days = days + countDays(el);
    });
    return days;
  };

  const getSickDaysMonth = (name, month) => {
    var holidays = props.holidaysData.filter(
      (el) =>
        el.user === name &&
        el.status === "ACCEPTED" &&
        el.type === "sick" &&
        new Date(el.date_from).getMonth() + 1 === month
    );
    var days = 0;
    holidays.map((el) => {
      days = days + countDays(el);
    });
    return days;
  };

  const getRemoteDays = (name) => {
    var holidays = props.holidaysData.filter(
      (el) =>
        el.user === name && el.status === "ACCEPTED" && el.type === "remote"
    );
    var days = 0;
    holidays.map((el) => {
      days = days + countDays(el);
    });
    return days;
  };

  const getEkwiwalentDays = (name) => {
    var holidays = props.holidaysData.filter(
      (el) =>
        el.user === name &&
        el.status === "ACCEPTED" &&
        el.type === "ekwiwalent" &&
        +new Date(el.date_from).getFullYear() === +year
    );
    var days = 0;
    holidays.map((el) => {
      days = days + countDays(el);
    });
    return days;
  };

  const getRemoteDaysMonth = (name, month) => {
    var holidays = props.holidaysData.filter(
      (el) =>
        el.user === name &&
        el.status === "ACCEPTED" &&
        el.type === "remote" &&
        new Date(el.date_from).getMonth() + 1 === month
    );
    var days = 0;
    holidays.map((el) => {
      days = days + countDays(el);
    });
    return days;
  };

  const handleToggleMonth = (e) => {
    if (display === e.currentTarget.id) {
      setDisplay("");
    } else {
      setDisplay(e.currentTarget.id);
    }
  };

  const styleRowExp = { maxHeight: "100%" };

  const expandReportedBox = (e) => {
    setExpandReported(!expandReported);
    setExpandAccepted(false);
    setExpandUsed(false);
    setExpandRemote(false);
    setExpandSick(false);
  };

  const reportedHolidayData = (
    <>
      <button className="paymentMenuButton" onClick={expandReportedBox}>
        {!expandReported ? "Rozwiń" : "Zwiń"}
      </button>
      <div className={expandReported ? "expandShow" : "expandHidden"}>
        <div
          id="month1Reported"
          style={display === "month1Reported" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Styczeń - {getReportedDaysMonth(props.name, 1)} dni
          </div>
          <table className="holidays_table" id="holidays_table_reported">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data dodania</th>
            </tr>
            {props.holidaysData
              .filter(
                (el) =>
                  el.user === user.name &&
                  el.status === "REPORTED" &&
                  el.type === "holiday" &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 0
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td value={el.id}>{el.id}</td>
                    <td value={el.id}>{el.date_from}</td>
                    <td value={el.id}>{el.date_to}</td>
                    <td value={el.id}>
                      {new Date(el.date_added).getFullYear() +
                        "-" +
                        (new Date(el.date_added).getMonth() + 1 < 10
                          ? "0" + (new Date(el.date_added).getMonth() + 1)
                          : new Date(el.date_added).getMonth() + 1) +
                        "-" +
                        new Date(el.date_added).getDate()}
                    </td>
                  </tr>
                </>
              ))}
          </table>
        </div>

        <div
          id="month2Reported"
          style={display === "month2Reported" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Luty - {getReportedDaysMonth(props.name, 2)} dni
          </div>
          <table className="holidays_table" id="holidays_table_reported">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data dodania</th>
            </tr>
            {props.holidaysData
              .filter(
                (el) =>
                  el.user === user.name &&
                  el.status === "REPORTED" &&
                  el.type === "holiday" &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 1
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td value={el.id}>{el.id}</td>
                    <td value={el.id}>{el.date_from}</td>
                    <td value={el.id}>{el.date_to}</td>
                    <td value={el.id}>
                      {new Date(el.date_added).getFullYear() +
                        "-" +
                        (new Date(el.date_added).getMonth() + 1 < 10
                          ? "0" + (new Date(el.date_added).getMonth() + 1)
                          : new Date(el.date_added).getMonth() + 1) +
                        "-" +
                        new Date(el.date_added).getDate()}
                    </td>
                  </tr>
                </>
              ))}
          </table>
        </div>

        <div
          id="month3Reported"
          style={display === "month3Reported" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Marzec - {getReportedDaysMonth(props.name, 3)} dni
          </div>
          <table className="holidays_table" id="holidays_table_reported">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data dodania</th>
            </tr>
            {props.holidaysData
              .filter(
                (el) =>
                  el.user === user.name &&
                  el.status === "REPORTED" &&
                  el.type === "holiday" &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 2
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td value={el.id}>{el.id}</td>
                    <td value={el.id}>{el.date_from}</td>
                    <td value={el.id}>{el.date_to}</td>
                    <td value={el.id}>
                      {new Date(el.date_added).getFullYear() +
                        "-" +
                        (new Date(el.date_added).getMonth() + 1 < 10
                          ? "0" + (new Date(el.date_added).getMonth() + 1)
                          : new Date(el.date_added).getMonth() + 1) +
                        "-" +
                        new Date(el.date_added).getDate()}
                    </td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month4Reported"
          style={display === "month4Reported" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Kwiecień - {getReportedDaysMonth(props.name, 4)} dni
          </div>
          <table className="holidays_table" id="holidays_table_reported">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data dodania</th>
            </tr>
            {props.holidaysData
              .filter(
                (el) =>
                  el.user === user.name &&
                  el.status === "REPORTED" &&
                  el.type === "holiday" &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 3
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td value={el.id}>{el.id}</td>
                    <td value={el.id}>{el.date_from}</td>
                    <td value={el.id}>{el.date_to}</td>
                    <td value={el.id}>
                      {new Date(el.date_added).getFullYear() +
                        "-" +
                        (new Date(el.date_added).getMonth() + 1 < 10
                          ? "0" + (new Date(el.date_added).getMonth() + 1)
                          : new Date(el.date_added).getMonth() + 1) +
                        "-" +
                        new Date(el.date_added).getDate()}
                    </td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month5Reported"
          style={display === "month5Reported" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Maj - {getReportedDaysMonth(props.name, 5)} dni
          </div>
          <table className="holidays_table" id="holidays_table_reported">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data dodania</th>
            </tr>
            {props.holidaysData
              .filter(
                (el) =>
                  el.user === user.name &&
                  el.status === "REPORTED" &&
                  el.type === "holiday" &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 4
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td value={el.id}>{el.id}</td>
                    <td value={el.id}>{el.date_from}</td>
                    <td value={el.id}>{el.date_to}</td>
                    <td value={el.id}>
                      {new Date(el.date_added).getFullYear() +
                        "-" +
                        (new Date(el.date_added).getMonth() + 1 < 10
                          ? "0" + (new Date(el.date_added).getMonth() + 1)
                          : new Date(el.date_added).getMonth() + 1) +
                        "-" +
                        new Date(el.date_added).getDate()}
                    </td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month6Reported"
          style={display === "month6Reported" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Czerwiec - {getReportedDaysMonth(props.name, 6)} dni
          </div>
          <table className="holidays_table" id="holidays_table_reported">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data dodania</th>
            </tr>
            {props.holidaysData
              .filter(
                (el) =>
                  el.user === user.name &&
                  el.status === "REPORTED" &&
                  el.type === "holiday" &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 5
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td value={el.id}>{el.id}</td>
                    <td value={el.id}>{el.date_from}</td>
                    <td value={el.id}>{el.date_to}</td>
                    <td value={el.id}>
                      {new Date(el.date_added).getFullYear() +
                        "-" +
                        (new Date(el.date_added).getMonth() + 1 < 10
                          ? "0" + (new Date(el.date_added).getMonth() + 1)
                          : new Date(el.date_added).getMonth() + 1) +
                        "-" +
                        new Date(el.date_added).getDate()}
                    </td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month7Reported"
          style={display === "month7Reported" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Lipiec - {getReportedDaysMonth(props.name, 7)} dni
          </div>
          <table className="holidays_table" id="holidays_table_reported">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data dodania</th>
            </tr>
            {props.holidaysData
              .filter(
                (el) =>
                  el.user === user.name &&
                  el.status === "REPORTED" &&
                  el.type === "holiday" &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 6
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td value={el.id}>{el.id}</td>
                    <td value={el.id}>{el.date_from}</td>
                    <td value={el.id}>{el.date_to}</td>
                    <td value={el.id}>
                      {new Date(el.date_added).getFullYear() +
                        "-" +
                        (new Date(el.date_added).getMonth() + 1 < 10
                          ? "0" + (new Date(el.date_added).getMonth() + 1)
                          : new Date(el.date_added).getMonth() + 1) +
                        "-" +
                        new Date(el.date_added).getDate()}
                    </td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month8Reported"
          style={display === "month8Reported" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Sierpień - {getReportedDaysMonth(props.name, 8)} dni
          </div>
          <table className="holidays_table" id="holidays_table_reported">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data dodania</th>
            </tr>
            {props.holidaysData
              .filter(
                (el) =>
                  el.user === user.name &&
                  el.status === "REPORTED" &&
                  el.type === "holiday" &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 7
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td value={el.id}>{el.id}</td>
                    <td value={el.id}>{el.date_from}</td>
                    <td value={el.id}>{el.date_to}</td>
                    <td value={el.id}>
                      {new Date(el.date_added).getFullYear() +
                        "-" +
                        (new Date(el.date_added).getMonth() + 1 < 10
                          ? "0" + (new Date(el.date_added).getMonth() + 1)
                          : new Date(el.date_added).getMonth() + 1) +
                        "-" +
                        new Date(el.date_added).getDate()}
                    </td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month9Reported"
          style={display === "month9Reported" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Wrzesień - {getReportedDaysMonth(props.name, 9)} dni
          </div>
          <table className="holidays_table" id="holidays_table_reported">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data dodania</th>
            </tr>
            {props.holidaysData
              .filter(
                (el) =>
                  el.user === user.name &&
                  el.status === "REPORTED" &&
                  el.type === "holiday" &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 8
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td value={el.id}>{el.id}</td>
                    <td value={el.id}>{el.date_from}</td>
                    <td value={el.id}>{el.date_to}</td>
                    <td value={el.id}>
                      {new Date(el.date_added).getFullYear() +
                        "-" +
                        (new Date(el.date_added).getMonth() + 1 < 10
                          ? "0" + (new Date(el.date_added).getMonth() + 1)
                          : new Date(el.date_added).getMonth() + 1) +
                        "-" +
                        new Date(el.date_added).getDate()}
                    </td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month10Reported"
          style={display === "month10Reported" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Październik - {getReportedDaysMonth(props.name, 10)} dni
          </div>
          <table className="holidays_table" id="holidays_table_reported">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data dodania</th>
            </tr>
            {props.holidaysData
              .filter(
                (el) =>
                  el.user === user.name &&
                  el.status === "REPORTED" &&
                  el.type === "holiday" &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 9
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td value={el.id}>{el.id}</td>
                    <td value={el.id}>{el.date_from}</td>
                    <td value={el.id}>{el.date_to}</td>
                    <td value={el.id}>
                      {new Date(el.date_added).getFullYear() +
                        "-" +
                        (new Date(el.date_added).getMonth() + 1 < 10
                          ? "0" + (new Date(el.date_added).getMonth() + 1)
                          : new Date(el.date_added).getMonth() + 1) +
                        "-" +
                        new Date(el.date_added).getDate()}
                    </td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month11Reported"
          style={display === "month11Reported" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Listopad - {getReportedDaysMonth(props.name, 11)} dni
          </div>
          <table className="holidays_table" id="holidays_table_reported">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data dodania</th>
            </tr>
            {props.holidaysData
              .filter(
                (el) =>
                  el.user === user.name &&
                  el.status === "REPORTED" &&
                  el.type === "holiday" &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 10
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td value={el.id}>{el.id}</td>
                    <td value={el.id}>{el.date_from}</td>
                    <td value={el.id}>{el.date_to}</td>
                    <td value={el.id}>
                      {new Date(el.date_added).getFullYear() +
                        "-" +
                        (new Date(el.date_added).getMonth() + 1 < 10
                          ? "0" + (new Date(el.date_added).getMonth() + 1)
                          : new Date(el.date_added).getMonth() + 1) +
                        "-" +
                        new Date(el.date_added).getDate()}
                    </td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month12Reported"
          style={display === "month12Reported" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Grudzień - {getReportedDaysMonth(props.name, 12)} dni
          </div>
          <table className="holidays_table" id="holidays_table_reported">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data dodania</th>
            </tr>
            {props.holidaysData
              .filter(
                (el) =>
                  el.user === user.name &&
                  el.status === "REPORTED" &&
                  el.type === "holiday" &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 11
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td value={el.id}>{el.id}</td>
                    <td value={el.id}>{el.date_from}</td>
                    <td value={el.id}>{el.date_to}</td>
                    <td value={el.id}>
                      {new Date(el.date_added).getFullYear() +
                        "-" +
                        (new Date(el.date_added).getMonth() + 1 < 10
                          ? "0" + (new Date(el.date_added).getMonth() + 1)
                          : new Date(el.date_added).getMonth() + 1) +
                        "-" +
                        new Date(el.date_added).getDate()}
                    </td>
                  </tr>
                </>
              ))}
          </table>
        </div>
      </div>
    </>
  );

  const expandAcceptedBox = (e) => {
    setExpandAccepted(!expandAccepted);
    setExpandReported(false);
    setExpandUsed(false);
    setExpandRemote(false);
    setExpandSick(false);
  };

  const expandEkwiwalentBox = (e) => {
    setExpandAccepted(false);
    setExpandReported(false);
    setExpandUsed(false);
    setExpandRemote(false);
    setExpandSick(false);
    setExpandEkwiwalent(!expandEkwiwalent);
  };

  const expandUsedBox = (e) => {
    setExpandUsed(!expandUsed);
    setExpandReported(false);
    setExpandAccepted(false);
    setExpandRemote(false);
    setExpandSick(false);
  };

  const expandSickBox = (e) => {
    setExpandSick(!expandSick);
    setExpandReported(false);
    setExpandAccepted(false);
    setExpandRemote(false);
    setExpandUsed(false);
  };

  const expandRemoteBox = (e) => {
    setExpandRemote(!expandRemote);
    setExpandReported(false);
    setExpandAccepted(false);
    setExpandSick(false);
    setExpandUsed(false);
  };

  const acceptedHolidayData = (
    <>
      <button className="paymentMenuButton" onClick={expandAcceptedBox}>
        {!expandAccepted ? "Rozwiń" : "Zwiń"}
      </button>
      <div className={expandAccepted ? "expandShow" : "expandHidden"}>
        <div
          id="month1Accepted"
          style={display === "month1Accepted" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Styczeń - {getAcceptedDaysMonth(props.name, 1)} dni
          </div>
          <table className="holidays_table" id="holidays_table_accepted">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data akceptacji</th>
            </tr>
            {props.holidaysData
              .filter(
                (el) =>
                  el.user === user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "holiday" &&
                  new Date(el.date_from) >= new Date() &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 0
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td>{el.id}</td>
                    <td>{el.date_from}</td>
                    <td>{el.date_to}</td>
                    <td>{el.date_accepted}</td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month2Accepted"
          style={display === "month2Accepted" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Luty - {getAcceptedDaysMonth(props.name, 2)} dni
          </div>
          <table className="holidays_table" id="holidays_table_accepted">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data akceptacji</th>
            </tr>
            {props.holidaysData
              .filter(
                (el) =>
                  el.user === user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "holiday" &&
                  new Date(el.date_from) >= new Date() &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 1
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td>{el.id}</td>
                    <td>{el.date_from}</td>
                    <td>{el.date_to}</td>
                    <td>{el.date_accepted}</td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month3Accepted"
          style={display === "month3Accepted" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Marzec - {getAcceptedDaysMonth(props.name, 3)} dni
          </div>
          <table className="holidays_table" id="holidays_table_accepted">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data akceptacji</th>
            </tr>
            {props.holidaysData
              .filter(
                (el) =>
                  el.user === user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "holiday" &&
                  new Date(el.date_from) >= new Date() &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 2
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td>{el.id}</td>
                    <td>{el.date_from}</td>
                    <td>{el.date_to}</td>
                    <td>{el.date_accepted}</td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month4Accepted"
          style={display === "month4Accepted" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Kwiecień - {getAcceptedDaysMonth(props.name, 4)} dni
          </div>
          <table className="holidays_table" id="holidays_table_accepted">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data akceptacji</th>
            </tr>
            {props.holidaysData
              .filter(
                (el) =>
                  el.user === user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "holiday" &&
                  new Date(el.date_from) >= new Date() &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 3
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td>{el.id}</td>
                    <td>{el.date_from}</td>
                    <td>{el.date_to}</td>
                    <td>{el.date_accepted}</td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month5Accepted"
          style={display === "month5Accepted" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Maj - {getAcceptedDaysMonth(props.name, 5)} dni
          </div>
          <table className="holidays_table" id="holidays_table_accepted">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data akceptacji</th>
            </tr>
            {props.holidaysData
              .filter(
                (el) =>
                  el.user === user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "holiday" &&
                  new Date(el.date_from) >= new Date() &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 4
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td>{el.id}</td>
                    <td>{el.date_from}</td>
                    <td>{el.date_to}</td>
                    <td>{el.date_accepted}</td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month6Accepted"
          style={display === "month6Accepted" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Czerwiec - {getAcceptedDaysMonth(props.name, 6)} dni
          </div>
          <table className="holidays_table" id="holidays_table_accepted">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data akceptacji</th>
            </tr>
            {props.holidaysData
              .filter(
                (el) =>
                  el.user === user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "holiday" &&
                  new Date(el.date_from) >= new Date() &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 5
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td>{el.id}</td>
                    <td>{el.date_from}</td>
                    <td>{el.date_to}</td>
                    <td>{el.date_accepted}</td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month7Accepted"
          style={display === "month7Accepted" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Lipiec - {getAcceptedDaysMonth(props.name, 7)} dni
          </div>
          <table className="holidays_table" id="holidays_table_accepted">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data akceptacji</th>
            </tr>
            {props.holidaysData
              .filter(
                (el) =>
                  el.user === user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "holiday" &&
                  new Date(el.date_from) >= new Date() &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 6
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td>{el.id}</td>
                    <td>{el.date_from}</td>
                    <td>{el.date_to}</td>
                    <td>{el.date_accepted}</td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month8Accepted"
          style={display === "month8Accepted" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Sierpień - {getAcceptedDaysMonth(props.name, 8)} dni
          </div>
          <table className="holidays_table" id="holidays_table_accepted">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data akceptacji</th>
            </tr>
            {props.holidaysData
              .filter(
                (el) =>
                  el.user === user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "holiday" &&
                  new Date(el.date_from) >= new Date() &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 7
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td>{el.id}</td>
                    <td>{el.date_from}</td>
                    <td>{el.date_to}</td>
                    <td>{el.date_accepted}</td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month9Accepted"
          style={display === "month9Accepted" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Wrzesień - {getAcceptedDaysMonth(props.name, 9)} dni
          </div>
          <table className="holidays_table" id="holidays_table_accepted">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data akceptacji</th>
            </tr>
            {props.holidaysData
              .filter(
                (el) =>
                  el.user === user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "holiday" &&
                  new Date(el.date_from) >= new Date() &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 8
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td>{el.id}</td>
                    <td>{el.date_from}</td>
                    <td>{el.date_to}</td>
                    <td>{el.date_accepted}</td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month10Accepted"
          style={display === "month10Accepted" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Październik - {getAcceptedDaysMonth(props.name, 10)} dni
          </div>
          <table className="holidays_table" id="holidays_table_accepted">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data akceptacji</th>
            </tr>
            {props.holidaysData
              .filter(
                (el) =>
                  el.user === user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "holiday" &&
                  new Date(el.date_from) >= new Date() &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 9
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td>{el.id}</td>
                    <td>{el.date_from}</td>
                    <td>{el.date_to}</td>
                    <td>{el.date_accepted}</td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month11Accepted"
          style={display === "month11Accepted" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Listopad - {getAcceptedDaysMonth(props.name, 11)} dni
          </div>
          <table className="holidays_table" id="holidays_table_accepted">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data akceptacji</th>
            </tr>
            {props.holidaysData
              .filter(
                (el) =>
                  el.user === user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "holiday" &&
                  new Date(el.date_from) >= new Date() &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 10
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td>{el.id}</td>
                    <td>{el.date_from}</td>
                    <td>{el.date_to}</td>
                    <td>{el.date_accepted}</td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month12Accepted"
          style={display === "month12Accepted" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Grudzień - {getAcceptedDaysMonth(props.name, 12)} dni
          </div>
          <table className="holidays_table" id="holidays_table_accepted">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data akceptacji</th>
            </tr>
            {props.holidaysData
              .filter(
                (el) =>
                  el.user === user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "holiday" &&
                  new Date(el.date_from) >= new Date() &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 11
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td>{el.id}</td>
                    <td>{el.date_from}</td>
                    <td>{el.date_to}</td>
                    <td>{el.date_accepted}</td>
                  </tr>
                </>
              ))}
          </table>
        </div>
      </div>
    </>
  );

  const ekwiwalentHolidayData = (
    <>
      <button className="paymentMenuButton" onClick={expandEkwiwalentBox}>
        {!expandEkwiwalent ? "Rozwiń" : "Zwiń"}
      </button>
      <div className={expandEkwiwalent ? "expandShow" : "expandHidden"}>
        <div
          id="month1Accepted"
          style={display === "month1Accepted" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Styczeń - {getEkwiwalentDaysMonth(props.name, 1)} dni
          </div>
          <table className="holidays_table" id="holidays_table_accepted">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data akceptacji</th>
            </tr>
            {holidaysData
              .filter(
                (el) =>
                  el.user === user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "ekwiwalent" &&
                  new Date(el.date_from).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 0
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td>{el.id}</td>
                    <td>{el.date_from}</td>
                    <td>{el.date_to}</td>
                    <td>{el.date_accepted}</td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month2Accepted"
          style={display === "month2Accepted" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Luty - {getEkwiwalentDaysMonth(props.name, 2)} dni
          </div>
          <table className="holidays_table" id="holidays_table_accepted">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data akceptacji</th>
            </tr>
            {props.holidaysData
              .filter(
                (el) =>
                  el.user === user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "ekwiwalent" &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 1
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td>{el.id}</td>
                    <td>{el.date_from}</td>
                    <td>{el.date_to}</td>
                    <td>{el.date_accepted}</td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month3Accepted"
          style={display === "month3Accepted" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Marzec - {getEkwiwalentDaysMonth(props.name, 3)} dni
          </div>
          <table className="holidays_table" id="holidays_table_accepted">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data akceptacji</th>
            </tr>
            {props.holidaysData
              .filter(
                (el) =>
                  el.user === user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "ekwiwalent" &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 2
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td>{el.id}</td>
                    <td>{el.date_from}</td>
                    <td>{el.date_to}</td>
                    <td>{el.date_accepted}</td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month4Accepted"
          style={display === "month4Accepted" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Kwiecień - {getEkwiwalentDaysMonth(props.name, 4)} dni
          </div>
          <table className="holidays_table" id="holidays_table_accepted">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data akceptacji</th>
            </tr>
            {props.holidaysData
              .filter(
                (el) =>
                  el.user === user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "ekwiwalent" &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 3
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td>{el.id}</td>
                    <td>{el.date_from}</td>
                    <td>{el.date_to}</td>
                    <td>{el.date_accepted}</td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month5Accepted"
          style={display === "month5Accepted" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Maj - {getEkwiwalentDaysMonth(props.name, 5)} dni
          </div>
          <table className="holidays_table" id="holidays_table_accepted">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data akceptacji</th>
            </tr>
            {props.holidaysData
              .filter(
                (el) =>
                  el.user === user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "ekwiwalent" &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 4
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td>{el.id}</td>
                    <td>{el.date_from}</td>
                    <td>{el.date_to}</td>
                    <td>{el.date_accepted}</td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month6Accepted"
          style={display === "month6Accepted" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Czerwiec - {getEkwiwalentDaysMonth(props.name, 6)} dni
          </div>
          <table className="holidays_table" id="holidays_table_accepted">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data akceptacji</th>
            </tr>
            {props.holidaysData
              .filter(
                (el) =>
                  el.user === user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "ekwiwalent" &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 5
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td>{el.id}</td>
                    <td>{el.date_from}</td>
                    <td>{el.date_to}</td>
                    <td>{el.date_accepted}</td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month7Accepted"
          style={display === "month7Accepted" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Lipiec - {getEkwiwalentDaysMonth(props.name, 7)} dni
          </div>
          <table className="holidays_table" id="holidays_table_accepted">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data akceptacji</th>
            </tr>
            {props.holidaysData
              .filter(
                (el) =>
                  el.user === user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "ekwiwalent" &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 6
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td>{el.id}</td>
                    <td>{el.date_from}</td>
                    <td>{el.date_to}</td>
                    <td>{el.date_accepted}</td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month8Accepted"
          style={display === "month8Accepted" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Sierpień - {getEkwiwalentDaysMonth(props.name, 8)} dni
          </div>
          <table className="holidays_table" id="holidays_table_accepted">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data akceptacji</th>
            </tr>
            {props.holidaysData
              .filter(
                (el) =>
                  el.user === user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "ekwiwalent" &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 7
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td>{el.id}</td>
                    <td>{el.date_from}</td>
                    <td>{el.date_to}</td>
                    <td>{el.date_accepted}</td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month9Accepted"
          style={display === "month9Accepted" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Wrzesień - {getEkwiwalentDaysMonth(props.name, 9)} dni
          </div>
          <table className="holidays_table" id="holidays_table_accepted">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data akceptacji</th>
            </tr>
            {props.holidaysData
              .filter(
                (el) =>
                  el.user === user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "ekwiwalent" &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 8
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td>{el.id}</td>
                    <td>{el.date_from}</td>
                    <td>{el.date_to}</td>
                    <td>{el.date_accepted}</td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month10Accepted"
          style={display === "month10Accepted" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Październik - {getEkwiwalentDaysMonth(props.name, 10)} dni
          </div>
          <table className="holidays_table" id="holidays_table_accepted">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data akceptacji</th>
            </tr>
            {props.holidaysData
              .filter(
                (el) =>
                  el.user === user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "ekwiwalent" &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 9
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td>{el.id}</td>
                    <td>{el.date_from}</td>
                    <td>{el.date_to}</td>
                    <td>{el.date_accepted}</td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month11Accepted"
          style={display === "month11Accepted" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Listopad - {getEkwiwalentDaysMonth(props.name, 11)} dni
          </div>
          <table className="holidays_table" id="holidays_table_accepted">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data akceptacji</th>
            </tr>
            {props.holidaysData
              .filter(
                (el) =>
                  el.user === user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "ekwiwalent" &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 10
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td>{el.id}</td>
                    <td>{el.date_from}</td>
                    <td>{el.date_to}</td>
                    <td>{el.date_accepted}</td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month12Accepted"
          style={display === "month12Accepted" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Grudzień - {getEkwiwalentDaysMonth(props.name, 12)} dni
          </div>
          <table className="holidays_table" id="holidays_table_accepted">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data akceptacji</th>
            </tr>
            {props.holidaysData
              .filter(
                (el) =>
                  el.user === user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "ekwiwalent" &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 11
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td>{el.id}</td>
                    <td>{el.date_from}</td>
                    <td>{el.date_to}</td>
                    <td>{el.date_accepted}</td>
                  </tr>
                </>
              ))}
          </table>
        </div>
      </div>
    </>
  );

  const usedHolidayData = (
    <>
      <button className="paymentMenuButton" onClick={expandUsedBox}>
        {!expandUsed ? "Rozwiń" : "Zwiń"}
      </button>
      <div className={expandUsed ? "expandShow" : "expandHidden"}>
        <div
          id="month1Used"
          style={display === "month1Used" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Styczeń - {getUsedDaysMonth(props.name, 1)} dni
          </div>
          <table className="holidays_table" id="holidays_table_used">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data akceptacji</th>
            </tr>
            {props.holidaysData
              .filter(
                (el) =>
                  el.user === user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "holiday" &&
                  new Date(el.date_from) < new Date() &&
                  +new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 0
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td>{el.id}</td>
                    <td>{el.date_from}</td>
                    <td>{el.date_to}</td>
                    <td>{el.date_accepted}</td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month2Used"
          style={display === "month2Used" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Luty - {getUsedDaysMonth(props.name, 2)} dni
          </div>
          <table className="holidays_table" id="holidays_table_used">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data akceptacji</th>
            </tr>
            {props.holidaysData
              .filter(
                (el) =>
                  el.user === user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "holiday" &&
                  new Date(el.date_from) < new Date() &&
                  +new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 1
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td>{el.id}</td>
                    <td>{el.date_from}</td>
                    <td>{el.date_to}</td>
                    <td>{el.date_accepted}</td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month3Used"
          style={display === "month3Used" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Marzec - {getUsedDaysMonth(props.name, 3)} dni
          </div>
          <table className="holidays_table" id="holidays_table_used">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data akceptacji</th>
            </tr>
            {props.holidaysData
              .filter(
                (el) =>
                  el.user === user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "holiday" &&
                  new Date(el.date_from) < new Date() &&
                  +new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 2
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td>{el.id}</td>
                    <td>{el.date_from}</td>
                    <td>{el.date_to}</td>
                    <td>{el.date_accepted}</td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month4Used"
          style={display === "month4Used" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Kwiecień - {getUsedDaysMonth(props.name, 4)} dni
          </div>
          <table className="holidays_table" id="holidays_table_used">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data akceptacji</th>
            </tr>
            {props.holidaysData
              .filter(
                (el) =>
                  el.user === user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "holiday" &&
                  new Date(el.date_from) < new Date() &&
                  +new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 3
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td>{el.id}</td>
                    <td>{el.date_from}</td>
                    <td>{el.date_to}</td>
                    <td>{el.date_accepted}</td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month5Used"
          style={display === "month5Used" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Maj - {getUsedDaysMonth(props.name, 5)} dni
          </div>
          <table className="holidays_table" id="holidays_table_used">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data akceptacji</th>
            </tr>
            {props.holidaysData
              .filter(
                (el) =>
                  el.user === user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "holiday" &&
                  new Date(el.date_from) < new Date() &&
                  +new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 4
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td>{el.id}</td>
                    <td>{el.date_from}</td>
                    <td>{el.date_to}</td>
                    <td>{el.date_accepted}</td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month6Used"
          style={display === "month6Used" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Czerwiec - {getUsedDaysMonth(props.name, 6)} dni
          </div>
          <table className="holidays_table" id="holidays_table_used">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data akceptacji</th>
            </tr>
            {props.holidaysData
              .filter(
                (el) =>
                  el.user === user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "holiday" &&
                  new Date(el.date_from) < new Date() &&
                  +new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 5
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td>{el.id}</td>
                    <td>{el.date_from}</td>
                    <td>{el.date_to}</td>
                    <td>{el.date_accepted}</td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month7Used"
          style={display === "month7Used" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Lipiec - {getUsedDaysMonth(props.name, 7)} dni
          </div>
          <table className="holidays_table" id="holidays_table_used">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data akceptacji</th>
            </tr>
            {props.holidaysData
              .filter(
                (el) =>
                  el.user === user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "holiday" &&
                  new Date(el.date_from) < new Date() &&
                  +new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 6
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td>{el.id}</td>
                    <td>{el.date_from}</td>
                    <td>{el.date_to}</td>
                    <td>{el.date_accepted}</td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month8Used"
          style={display === "month8Used" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Sierpień - {getUsedDaysMonth(props.name, 8)} dni
          </div>
          <table className="holidays_table" id="holidays_table_used">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data akceptacji</th>
            </tr>
            {props.holidaysData
              .filter(
                (el) =>
                  el.user === user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "holiday" &&
                  new Date(el.date_from) < new Date() &&
                  +new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 7
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td>{el.id}</td>
                    <td>{el.date_from}</td>
                    <td>{el.date_to}</td>
                    <td>{el.date_accepted}</td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month9Used"
          style={display === "month9Used" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Wrzesień - {getUsedDaysMonth(props.name, 9)} dni
          </div>
          <table className="holidays_table" id="holidays_table_used">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data akceptacji</th>
            </tr>
            {props.holidaysData
              .filter(
                (el) =>
                  el.user === user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "holiday" &&
                  new Date(el.date_from) < new Date() &&
                  +new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 8
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td>{el.id}</td>
                    <td>{el.date_from}</td>
                    <td>{el.date_to}</td>
                    <td>{el.date_accepted}</td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month10Used"
          style={display === "month10Used" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Październik - {getUsedDaysMonth(props.name, 10)} dni
          </div>
          <table className="holidays_table" id="holidays_table_used">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data akceptacji</th>
            </tr>
            {props.holidaysData
              .filter(
                (el) =>
                  el.user === user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "holiday" &&
                  new Date(el.date_from) < new Date() &&
                  +new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 9
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td>{el.id}</td>
                    <td>{el.date_from}</td>
                    <td>{el.date_to}</td>
                    <td>{el.date_accepted}</td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month11Used"
          style={display === "month11Used" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Listopad - {getUsedDaysMonth(props.name, 11)} dni
          </div>
          <table className="holidays_table" id="holidays_table_used">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data akceptacji</th>
            </tr>
            {props.holidaysData
              .filter(
                (el) =>
                  el.user === user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "holiday" &&
                  new Date(el.date_from) < new Date() &&
                  +new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 10
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td>{el.id}</td>
                    <td>{el.date_from}</td>
                    <td>{el.date_to}</td>
                    <td>{el.date_accepted}</td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month12Used"
          style={display === "month12Used" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Grudzień - {getUsedDaysMonth(props.name, 12)} dni
          </div>
          <table className="holidays_table" id="holidays_table_used">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data akceptacji</th>
            </tr>
            {props.holidaysData
              .filter(
                (el) =>
                  el.user === user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "holiday" &&
                  new Date(el.date_from) < new Date() &&
                  +new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 11
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td>{el.id}</td>
                    <td>{el.date_from}</td>
                    <td>{el.date_to}</td>
                    <td>{el.date_accepted}</td>
                  </tr>
                </>
              ))}
          </table>
        </div>
      </div>
    </>
  );

  const sickHolidayData = (
    <>
      <button className="paymentMenuButton" onClick={expandSickBox}>
        {!expandSick ? "Rozwiń" : "Zwiń"}
      </button>
      <div className={expandSick ? "expandShow" : "expandHidden"}>
        <div
          id="month1Sick"
          style={display === "month1Sick" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Styczeń - {getSickDaysMonth(props.name, 1)} dni
          </div>
          <table className="holidays_table" id="holidays_table_sick">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data akceptacji</th>
            </tr>
            {props.holidaysData
              .filter(
                (el) =>
                  el.user === user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "sick" &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 0
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td>{el.id}</td>
                    <td>{el.date_from}</td>
                    <td>{el.date_to}</td>
                    <td>{el.date_accepted}</td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month2Sick"
          style={display === "month2Sick" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Luty - {getSickDaysMonth(props.name, 2)} dni
          </div>
          <table className="holidays_table" id="holidays_table_sick">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data akceptacji</th>
            </tr>
            {props.holidaysData
              .filter(
                (el) =>
                  el.user === user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "sick" &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 1
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td>{el.id}</td>
                    <td>{el.date_from}</td>
                    <td>{el.date_to}</td>
                    <td>{el.date_accepted}</td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month3Sick"
          style={display === "month3Sick" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Marzec - {getSickDaysMonth(props.name, 3)} dni
          </div>
          <table className="holidays_table" id="holidays_table_sick">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data akceptacji</th>
            </tr>
            {props.holidaysData
              .filter(
                (el) =>
                  el.user === user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "sick" &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 2
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td>{el.id}</td>
                    <td>{el.date_from}</td>
                    <td>{el.date_to}</td>
                    <td>{el.date_accepted}</td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month4Sick"
          style={display === "month4Sick" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Kwiecień - {getSickDaysMonth(props.name, 4)} dni
          </div>
          <table className="holidays_table" id="holidays_table_sick">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data akceptacji</th>
            </tr>
            {props.holidaysData
              .filter(
                (el) =>
                  el.user === user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "sick" &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 3
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td>{el.id}</td>
                    <td>{el.date_from}</td>
                    <td>{el.date_to}</td>
                    <td>{el.date_accepted}</td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month5Sick"
          style={display === "month5Sick" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Maj - {getSickDaysMonth(props.name, 5)} dni
          </div>
          <table className="holidays_table" id="holidays_table_sick">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data akceptacji</th>
            </tr>
            {props.holidaysData
              .filter(
                (el) =>
                  el.user === user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "sick" &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 4
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td>{el.id}</td>
                    <td>{el.date_from}</td>
                    <td>{el.date_to}</td>
                    <td>{el.date_accepted}</td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month6Sick"
          style={display === "month6Sick" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Czerwiec - {getSickDaysMonth(props.name, 6)} dni
          </div>
          <table className="holidays_table" id="holidays_table_sick">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data akceptacji</th>
            </tr>
            {props.holidaysData
              .filter(
                (el) =>
                  el.user === user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "sick" &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 5
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td>{el.id}</td>
                    <td>{el.date_from}</td>
                    <td>{el.date_to}</td>
                    <td>{el.date_accepted}</td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month7Sick"
          style={display === "month7Sick" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Lipiec - {getSickDaysMonth(props.name, 7)} dni
          </div>
          <table className="holidays_table" id="holidays_table_sick">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data akceptacji</th>
            </tr>
            {props.holidaysData
              .filter(
                (el) =>
                  el.user === user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "sick" &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 6
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td>{el.id}</td>
                    <td>{el.date_from}</td>
                    <td>{el.date_to}</td>
                    <td>{el.date_accepted}</td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month8Sick"
          style={display === "month8Sick" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Sierpień - {getSickDaysMonth(props.name, 8)} dni
          </div>
          <table className="holidays_table" id="holidays_table_sick">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data akceptacji</th>
            </tr>
            {props.holidaysData
              .filter(
                (el) =>
                  el.user === user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "sick" &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 7
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td>{el.id}</td>
                    <td>{el.date_from}</td>
                    <td>{el.date_to}</td>
                    <td>{el.date_accepted}</td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month9Sick"
          style={display === "month9Sick" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Wrzesień - {getSickDaysMonth(props.name, 9)} dni
          </div>
          <table className="holidays_table" id="holidays_table_sick">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data akceptacji</th>
            </tr>
            {props.holidaysData
              .filter(
                (el) =>
                  el.user === user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "sick" &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 8
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td>{el.id}</td>
                    <td>{el.date_from}</td>
                    <td>{el.date_to}</td>
                    <td>{el.date_accepted}</td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month10Sick"
          style={display === "month10Sick" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Październik - {getSickDaysMonth(props.name, 10)} dni
          </div>
          <table className="holidays_table" id="holidays_table_sick">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data akceptacji</th>
            </tr>
            {props.holidaysData
              .filter(
                (el) =>
                  el.user === user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "sick" &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 9
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td>{el.id}</td>
                    <td>{el.date_from}</td>
                    <td>{el.date_to}</td>
                    <td>{el.date_accepted}</td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month11Sick"
          style={display === "month11Sick" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Listopad - {getSickDaysMonth(props.name, 11)} dni
          </div>
          <table className="holidays_table" id="holidays_table_sick">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data akceptacji</th>
            </tr>
            {props.holidaysData
              .filter(
                (el) =>
                  el.user === user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "sick" &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 10
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td>{el.id}</td>
                    <td>{el.date_from}</td>
                    <td>{el.date_to}</td>
                    <td>{el.date_accepted}</td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month12Sick"
          style={display === "month12Sick" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Grudzień - {getSickDaysMonth(props.name, 12)} dni
          </div>
          <table className="holidays_table" id="holidays_table_sick">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data akceptacji</th>
            </tr>
            {props.holidaysData
              .filter(
                (el) =>
                  el.user === user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "sick" &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 11
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td>{el.id}</td>
                    <td>{el.date_from}</td>
                    <td>{el.date_to}</td>
                    <td>{el.date_accepted}</td>
                  </tr>
                </>
              ))}
          </table>
        </div>
      </div>
    </>
  );

  const remoteHolidayData = (
    <>
      <button className="paymentMenuButton" onClick={expandRemoteBox}>
        {!expandRemote ? "Rozwiń" : "Zwiń"}
      </button>
      <div className={expandRemote ? "expandShow" : "expandHidden"}>
        <div
          id="month1Remote"
          style={display === "month1Remote" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Styczeń - {getRemoteDaysMonth(props.name, 1)} dni
          </div>
          <table className="holidays_table" id="holidays_table_remote">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data akceptacji</th>
            </tr>
            {props.holidaysData
              .filter(
                (el) =>
                  el.user === user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "remote" &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 0
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td>{el.id}</td>
                    <td>{el.date_from}</td>
                    <td>{el.date_to}</td>
                    <td>{el.date_accepted}</td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month2Remote"
          style={display === "month2Remote" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Luty - {getRemoteDaysMonth(props.name, 2)} dni
          </div>
          <table className="holidays_table" id="holidays_table_remote">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data akceptacji</th>
            </tr>
            {props.holidaysData
              .filter(
                (el) =>
                  el.user === user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "remote" &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 1
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td>{el.id}</td>
                    <td>{el.date_from}</td>
                    <td>{el.date_to}</td>
                    <td>{el.date_accepted}</td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month3Remote"
          style={display === "month3Remote" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Marzec - {getRemoteDaysMonth(props.name, 3)} dni
          </div>
          <table className="holidays_table" id="holidays_table_remote">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data akceptacji</th>
            </tr>
            {props.holidaysData
              .filter(
                (el) =>
                  el.user === user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "remote" &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 2
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td>{el.id}</td>
                    <td>{el.date_from}</td>
                    <td>{el.date_to}</td>
                    <td>{el.date_accepted}</td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month4Remote"
          style={display === "month4Remote" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Kwiecień - {getRemoteDaysMonth(props.name, 4)} dni
          </div>
          <table className="holidays_table" id="holidays_table_remote">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data akceptacji</th>
            </tr>
            {props.holidaysData
              .filter(
                (el) =>
                  el.user === user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "remote" &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 3
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td>{el.id}</td>
                    <td>{el.date_from}</td>
                    <td>{el.date_to}</td>
                    <td>{el.date_accepted}</td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month5Remote"
          style={display === "month5Remote" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Maj - {getRemoteDaysMonth(props.name, 5)} dni
          </div>
          <table className="holidays_table" id="holidays_table_remote">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data akceptacji</th>
            </tr>
            {props.holidaysData
              .filter(
                (el) =>
                  el.user === user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "remote" &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 4
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td>{el.id}</td>
                    <td>{el.date_from}</td>
                    <td>{el.date_to}</td>
                    <td>{el.date_accepted}</td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month6Remote"
          style={display === "month6Remote" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Czerwiec - {getRemoteDaysMonth(props.name, 6)} dni
          </div>
          <table className="holidays_table" id="holidays_table_remote">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data akceptacji</th>
            </tr>
            {props.holidaysData
              .filter(
                (el) =>
                  el.user === user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "remote" &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 5
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td>{el.id}</td>
                    <td>{el.date_from}</td>
                    <td>{el.date_to}</td>
                    <td>{el.date_accepted}</td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month7Remote"
          style={display === "month7Remote" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Lipiec - {getRemoteDaysMonth(props.name, 7)} dni
          </div>
          <table className="holidays_table" id="holidays_table_remote">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data akceptacji</th>
            </tr>
            {props.holidaysData
              .filter(
                (el) =>
                  el.user === user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "remote" &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 6
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td>{el.id}</td>
                    <td>{el.date_from}</td>
                    <td>{el.date_to}</td>
                    <td>{el.date_accepted}</td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month8Remote"
          style={display === "month8Remote" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Sierpień - {getRemoteDaysMonth(props.name, 8)} dni
          </div>
          <table className="holidays_table" id="holidays_table_remote">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data akceptacji</th>
            </tr>
            {props.holidaysData
              .filter(
                (el) =>
                  el.user === user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "remote" &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 7
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td>{el.id}</td>
                    <td>{el.date_from}</td>
                    <td>{el.date_to}</td>
                    <td>{el.date_accepted}</td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month9Remote"
          style={display === "month9Remote" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Wrzesień - {getRemoteDaysMonth(props.name, 9)} dni
          </div>
          <table className="holidays_table" id="holidays_table_remote">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data akceptacji</th>
            </tr>
            {props.holidaysData
              .filter(
                (el) =>
                  el.user === user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "remote" &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 8
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td>{el.id}</td>
                    <td>{el.date_from}</td>
                    <td>{el.date_to}</td>
                    <td>{el.date_accepted}</td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month10Remote"
          style={display === "month10Remote" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Październik - {getRemoteDaysMonth(props.name, 10)} dni
          </div>
          <table className="holidays_table" id="holidays_table_remote">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data akceptacji</th>
            </tr>
            {props.holidaysData
              .filter(
                (el) =>
                  el.user === user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "remote" &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 9
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td>{el.id}</td>
                    <td>{el.date_from}</td>
                    <td>{el.date_to}</td>
                    <td>{el.date_accepted}</td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month11Remote"
          style={display === "month11Remote" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Listopad - {getRemoteDaysMonth(props.name, 11)} dni
          </div>
          <table className="holidays_table" id="holidays_table_remote">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data akceptacji</th>
            </tr>
            {props.holidaysData
              .filter(
                (el) =>
                  el.user === user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "remote" &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 10
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td>{el.id}</td>
                    <td>{el.date_from}</td>
                    <td>{el.date_to}</td>
                    <td>{el.date_accepted}</td>
                  </tr>
                </>
              ))}
          </table>
        </div>
        <div
          id="month12Remote"
          style={display === "month12Remote" ? styleRowExp : {}}
          className="monthRow"
          onClick={handleToggleMonth}
        >
          <div className="monthInfo">
            Grudzień - {getRemoteDaysMonth(props.name, 12)} dni
          </div>
          <table className="holidays_table" id="holidays_table_remote">
            <tr key={0}>
              <th>ID</th>
              <th>Data od</th>
              <th>Data do</th>
              <th>Data akceptacji</th>
            </tr>
            {props.holidaysData
              .filter(
                (el) =>
                  el.user === user.name &&
                  el.status === "ACCEPTED" &&
                  el.type === "remote" &&
                  new Date(el.date_to).getFullYear() === +year &&
                  new Date(el.date_from).getMonth() === 11
              )
              .map((el) => (
                <>
                  <tr key={el.id}>
                    <td>{el.id}</td>
                    <td>{el.date_from}</td>
                    <td>{el.date_to}</td>
                    <td>{el.date_accepted}</td>
                  </tr>
                </>
              ))}
          </table>
        </div>
      </div>
    </>
  );

  const getDays = () => {
    var arr = props.users.filter((el) => el.name === props.name)[0];
    var data = props.yearHolidaysData.filter(
      (el) => el.name === arr.name && +el.year === +year
    )[0];
    return data.days;
  };

  const calendarMonthNew = (
    <>
      <div className="rowCalendar">
        <div id="hudTitle" className="rowHolidayUser">
          {user.name} - rok {year}
        </div>
      </div>
      <div className="rowCalendar">
        <div className="rowHolidayUser">
          <p>
            Ilość dni urlopu: <span id="boldPart">{getDays()}</span>
          </p>
          <p>
            Ilość dni urlopu wnioskowanego:{" "}
            <span id="boldPart">{getReportedDays(user.name)}</span>
          </p>
          <p>
            Ilość dni urlopu zaakceptowanego:{" "}
            <span id="boldPart">
              {getAcceptedDays(user.name) - getUsedDays(user.name) < 0
                ? 0
                : getAcceptedDays(user.name) - getUsedDays(user.name)}
            </span>
          </p>
          <p>
            Ilość dni urlopu wykorzystanego:{" "}
            <span id="boldPart">{getUsedDays(user.name)}</span>
          </p>
          <p>
            Pozostałe dni urlopu:{" "}
            <span id="boldPart">
              {getDays(user.name) -
                (getAcceptedDays(user.name) -
                  getUsedDays(user.name) +
                  getUsedDays(user.name) +
                  getReportedDays(user.name) +
                  getEkwiwalentDays(user.name))}
            </span>
          </p>
          <br />
          {getEkwiwalentDays(user.name) > 0 ? (
            <>
              <p className="main_h_info_label">
                <span id="label_h">Wypłacony ekwiwalent: </span>
                <span id="boldPartH">{getEkwiwalentDays(user.name)}</span>
              </p>
            </>
          ) : (
            ""
          )}
          <p>
            Ilość dni zwolnienia chorobowego:{" "}
            <span id="boldPart">{getSickDays(user.name)}</span>
          </p>
          {user.urlopyZdalna === 1 ? (
            <p>
              Ilość dni pracy zdalnej:{" "}
              <span id="boldPart">{getRemoteDays(user.name)}</span>
            </p>
          ) : (
            ""
          )}
        </div>
      </div>
      <div className="holidaysBox">
        <p className="holidayTitle">WNIOSKI URLOPOWE ZGŁOSZONE</p>
        {reportedHolidayData}
      </div>
      <div className="holidaysBox">
        <p className="holidayTitle">WNIOSKI URLOPOWE ZAAKCEPTOWANE</p>
        {acceptedHolidayData}
      </div>
      <div className="holidaysBox">
        <p className="holidayTitle">URLOP WYKORZYSTANY</p>
        {usedHolidayData}
      </div>
      <div className="holidaysBox">
        <p className="holidayTitle">ZWOLNIENIA CHOROBOWE</p>
        {sickHolidayData}
      </div>
      {user.urlopyZdalna === 1 ? (
        <div className="holidaysBox">
          <p className="holidayTitle">OKRESY PRACY ZDALNEJ</p>
          {remoteHolidayData}
        </div>
      ) : (
        ""
      )}
      {props.user.urlopyAdmin === "1" ? (
        <div className="holidaysBox">
          <p className="holidayTitle">EKWIWALENTY</p>
          {ekwiwalentHolidayData}
        </div>
      ) : (
        ""
      )}
    </>
  );

  const handleYearChange = (e) => {
    setYear(e.target.value);
  };

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <>
          <div className="mainContainerCalendar">
            <div id="selCloseBox" className="closeBox">
              <select
                type="text"
                id="filterO"
                name="court"
                value={year}
                onChange={handleYearChange}
              >
                {years.map((el) => (
                  <option key={el} value={el}>
                    {el}
                  </option>
                ))}
              </select>
              <div className="closeBox">
                <button className="closeClientButton" onClick={props.close}>
                  X
                </button>
              </div>
            </div>
            {calendarMonthNew}
          </div>
        </>
      )}
    </>
  );
};

export default HolidayUserDetails;
